import { LocalizationProvider, DatePicker as MuiDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import * as moment from "moment";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";

export interface IDatePickerProp {
    autoFocus?: boolean;
    classes?: string;
    clearable?: boolean;
    disabled?: boolean;
    required?: boolean;
    value?: string;
    minDate?: string;
    maxDate?: string;
    onChange(value: string);
}

export const DatePicker = ({ value, autoFocus, clearable, disabled, required, minDate, maxDate, onChange }: IDatePickerProp) => {
    const handleChange = (value: moment.Moment | string) => {
        onChange(typeof value === "string"
            ? (value ?? "")
            : Base.timeToDateStr(value));
    };

    const getLanguageLocale = (culture: string) => {
        switch (culture) {
        case "fi":
            return "fi";
        case "en":
        case "en-US":
            return "en";
        case "sv":
            return "se";
        }
    };

    const getLocaleDate = (stringDate: string) => {
        if (!stringDate?.length) return undefined;
        const parts = stringDate.split(".");
        return moment.utc(`${Base.padZeros(parts[2], 4)}-${Base.padZeros(parts[1], 2)}-${Base.padZeros(parts[0], 2)}`);
    };

    // React.useEffect(() => {
    //     console.log("React.useEffect", value, getLanguageLocale(appConfig.culture));
    // }, [value]);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={getLanguageLocale(appConfig.culture)}>
            <MuiDatePicker
                value={value ? getLocaleDate(value) : null}
                disabled={disabled}
                autoFocus={autoFocus}
                minDate={minDate ? getLocaleDate(minDate) : undefined}
                maxDate={maxDate ? getLocaleDate(maxDate) : undefined}
                slotProps={{
                    textField: { size: "small", fullWidth: true },
                    field: { clearable: clearable ?? false }
                }}
                sx={{ width: "100%" }}
                onChange={handleChange}
            />
        </LocalizationProvider>
    );
};